(function () {
    'use strict';

    angular.module('app.categoryIcons', [
        'app.core',
        'app.widgets'
    ]);
})();
